import { FC, PropsWithChildren } from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";

interface IPremiumBody {
  customClassName?: string;
  customStyle?: any;
  noAlertbar?: boolean;
  maxWidth?: string | undefined;
}

const PremiumBody: FC<PropsWithChildren<IPremiumBody>> = (props) => {
  return (
    <Box
      component="section"
      className={clsx(props.customClassName || "", "relative")}
      style={props.customStyle || {}}
      maxWidth={props.maxWidth}
    >
      {props.children}
    </Box>
  );
};

export default PremiumBody;
